import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { SetPasswordPage } from '@/features/auth';

const setPasswordSearchSchema = z.object({
  token: z.string().optional(),
});

export const Route = createFileRoute('/_public/set-password')({
  validateSearch: zodValidator(setPasswordSearchSchema),
  component: SetPasswordRouteComponent,
});

function SetPasswordRouteComponent() {
  const search = Route.useSearch();

  return <SetPasswordPage token={search.token} />;
}
